/** What the app holds in page memory that the user entered or loaded (a subset of the app state). */
export interface EnteredState {
  json: string;
  exampleLoaded: boolean;
  answers: object;
  result: unknown;
  files: readonly unknown[];
  manual: Partial<Record<string, string>>;
  manualDates: Partial<Record<string, { day: string; month: string; year: string }>>;
  diag: { comment: string; feedback: object };
  /** Form 106 numbers typed in (used, or still in the form). */
  form106Manual?: unknown;
  form106Draft?: Partial<Record<string, string>>;
}

/**
 * True when a reload would wipe something: payslip data lives only in page memory, never stored
 * (src/pwa/register.ts reloads onto a new version only when this is false). The language choice
 * is stored, and the built-in example can be loaded again, so neither counts.
 */
export function hasUnsavedData(state: EnteredState): boolean {
  return (
    (state.json.trim() !== '' && !state.exampleLoaded) ||
    (state.result !== undefined && !state.exampleLoaded) ||
    Object.keys(state.answers).length > 0 ||
    state.files.length > 0 ||
    Object.values(state.manual).some((v) => v !== undefined && v.trim() !== '') ||
    Object.values(state.manualDates).some((d) => d !== undefined && (d.day !== '' || d.month !== '' || d.year !== '')) ||
    state.diag.comment.trim() !== '' ||
    Object.keys(state.diag.feedback).length > 0 ||
    state.form106Manual !== undefined ||
    Object.values(state.form106Draft ?? {}).some((v) => v !== undefined && v.trim() !== '')
  );
}
